<template>
  <div>
    <div class="handle">
      <!-- <el-button @click="batchDelete" :disabled="checkArray.length === 0"
        >批量移除</el-button> -->
      <el-button
        type="primary"
        @click="showAddModal"
        >新增</el-button>
    </div>
    <Table @selection-change="selectChange" :data="form.classForm.videoIncludeInfoList" @editContent="editContent" />
    <AddContent
      v-if="addDialog.flag"
      :index="curIndex"
      :addDialog="addDialog"
      @closeAddDialog="closeAddDialog"
      @addSucceed="addContentCheck"
    />
  </div>
</template>

<script>
import Table from "./table.js";
import { Confirm } from "@/components/Confirm";
import AddContent from "./addContent.vue";
export default {
  inject: ["form"],
  components: {
    Table,
    AddContent
  },
  data() {
    return {
      checkArray: [],
      list: [],
      addDialog: {
        flag: false,
        isEdit: false,
        editItem: {}
      },
      curIndex: -1,
    };
  },
  methods: {
    selectChange(selections) {
      this.checkArray = selections;
    },
    // 新增
    showAddModal() {
      this.addDialog.flag = true;
    },
    // 编辑审查
    editContent(item, index) {
      this.addDialog.flag = true;
      this.addDialog.isEdit = true;
      this.addDialog.editItem = JSON.parse(JSON.stringify(item));
      this.curIndex = index;
    },
    closeAddDialog() {
      this.addDialog.flag = false;
      this.addDialog.isEdit = false;
      this.addDialog.editItem = {};
    },
     // 新增/编辑审查成功
    addContentCheck(item) {
      if (!this.addDialog.isEdit) {
        this.form.classForm.videoIncludeInfoList = this.form.classForm.videoIncludeInfoList.concat(item);
      } else {
        this.form.classForm.videoIncludeInfoList.splice(this.curIndex, 1, item);
      }
      this.closeAddDialog();
    },
  },
};
</script>

<style lang="scss" scoped>
.pagination {
  margin-top: 10px;
}
.handle {
  text-align: right;
  margin-bottom: 10px;
}
</style>
